import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'checkbox-control',
  templateUrl: './checkbox-control.component.html',
  styleUrls: ['./checkbox-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckboxControlComponent,
    multi: true
  }]
})
export class CheckboxControlComponent extends BaseControl {

  @Input() public checkClass: string = 'filled-in';

  constructor() {
    super();
  }

  onWriteValue(value) {
    if (this.value === true || this.value === false) return;
    
    if (+this.value == 1) this.value = true;
    if (+this.value == 0) this.value = false;
    if (this.value == 'true') this.value = true;
    if (this.value == 'false') this.value = false;
  }

  ngOnInit() {
    if (!this.checkClass || this.checkClass == '') this.checkClass = 'filled-in';    
  }

  onCheck() {
    this.updateValue();
  }

}
